// Применяет CSS custom properties на shadow host element через inline-style.
// Inline style перебивает :host{} правила в shadow DOM, поэтому defaults
// из styles/index.css заменяются на значения из channel.params.widget.colors.
//
// Если --widget-primary-dark не задан явно, CSS сам выведет его через
// color-mix(in oklab, var(--widget-primary) 82%, black) — см. styles/index.css.

const HEX6 = /^#[0-9a-fA-F]{6}$/;

export function isValidHex(value: unknown): value is string {
  return typeof value === 'string' && HEX6.test(value);
}

export function applyTheme(
  host: HTMLElement,
  colors?: { primary?: string; primaryDark?: string },
): void {
  if (!colors) return;
  if (isValidHex(colors.primary)) {
    host.style.setProperty('--widget-primary', colors.primary);
  }
  if (isValidHex(colors.primaryDark)) {
    host.style.setProperty('--widget-primary-dark', colors.primaryDark);
  }
}
